import React from "react"

export const WarningIconMedium = ({ size = 1 }) => {
  return (
    <svg
      width={size * 32}
      height={size * 32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g transform="translate(.5 2)">
          <circle stroke="#035470" strokeWidth="2" cx="18" cy="13.5" r="12.5" />
          <circle fill="#E70023" cx="13.5" cy="14.5" r="13.5" />
          <path
            d="M14.581 17c.132-.751.235-1.475.309-2.172.073-.696.11-1.4.11-2.113V6h-3v6.715c0 .712.037 1.417.11 2.113.074.697.177 1.42.309 2.172h2.162zM13.5 23c.278 0 .538-.05.78-.15.24-.1.451-.24.631-.42s.323-.391.43-.634c.106-.242.159-.506.159-.79a2.028 2.028 0 0 0-.589-1.423c-.18-.18-.39-.322-.632-.426A1.94 1.94 0 0 0 13.5 19a1.97 1.97 0 0 0-1.423.583 2.026 2.026 0 0 0-.577 1.423c0 .284.051.548.153.79a1.936 1.936 0 0 0 1.055 1.053c.242.1.506.151.792.151z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
}
